import React from 'react';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import CustomInputWithIcon from '../../../common/ui/CustomInputWithIcon';

export const CdnForm = ({
  projectId,
  version,
  title,
  customComponentId,
  currentCdn,
  validateUrl,
  setToggle,
  onSubmit,
  onUpdate,
  isReadOnly,
}) => {
  const handleSubmit = (values, resetForm) => {
    if (currentCdn) {
      onUpdate({
        projectId,
        version,
        componentId: customComponentId,
        cdnId: currentCdn.uuid,
        urlOrTag: values.urlOrTag,
      });
    } else
      onSubmit({ projectId, version, componentId: customComponentId, urlOrTag: values.urlOrTag });
    setToggle(false);
    if (resetForm) resetForm();
  };

  return (
    <Formik
      initialValues={{ urlOrTag: currentCdn ? currentCdn.urlOrTag : '' }}
      onSubmit={(values, { resetForm }) => (isReadOnly ? null : handleSubmit(values, resetForm))}
    >
      {({ isSubmitting, setFieldValue, setFieldTouched, resetForm, errors }) => {
        return (
          <Form className="form-horizontal">
            <div className="row mx-auto">
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <CustomInputWithIcon title={title} icon="url">
                  <Field
                    name="urlOrTag"
                    className="form-control form-control-sm"
                    placeholder={`Insert your ${title} here..`}
                    validate={validateUrl}
                  />
                  <ErrorMessage name="urlOrTag">
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                </CustomInputWithIcon>
              </div>
              <div className="col-md-12 col-lg-12 text-right">
                <button
                  type="reset"
                  className="btn btn-default btn-md"
                  onClick={() => setToggle(false)}
                >
                  <span>
                    <i className={`wb ${drapcodeIcon('cancel')}`}></i>&nbsp;Cancel
                  </span>
                </button>
                &nbsp;
                <button
                  type="submit"
                  className="btn btn-theme-submit btn-md"
                  title={
                    isReadOnly ? 'Read-Only Mode' : `${currentCdn ? 'Update' : 'Add'} ${title}`
                  }
                  disabled={isReadOnly}
                >
                  <i className={`wb ${drapcodeIcon(currentCdn ? 'update' : 'create')}`}></i>
                  &nbsp;{currentCdn ? 'Update' : `Add ${title}`}
                </button>
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};
